/**
 * All-company_sites hook for the geofence sidebar (DISPATCH-04 / GEO-02 — Blocker 2 fix).
 *
 * Phase 9 / Plan 09-06 — sources the sidebar from GET /v1/sites (Plan 09-01) which
 * returns ALL of the tenant's company_sites INCLUDING sites that have no jobs yet.
 * This satisfies Blocker 2: a dispatcher can geofence a brand-new site before any job
 * exists for it. DO NOT use useJobs here — that only surfaces sites with existing jobs.
 *
 * geofenceExists=true when an active PICKUP polygon exists (the Verified badge signal).
 *
 * Spec: 09-06-PLAN.md Task 2; <interfaces> "Site list source (Blocker 2 fix)".
 */

import type { SiteSummary } from '@lodex-pro/shared';
import type { UseQueryResult } from '@tanstack/react-query';
import { useApiQuery, useApiOpts } from '@lodex-pro/web-shared';

// ---------------------------------------------------------------------------
// Query key — exported so use-geofence's onSuccess can invalidate it
// ---------------------------------------------------------------------------

export const SITES_QUERY_KEY = ['sites', 'list'] as const;

// ---------------------------------------------------------------------------
// Hook
// ---------------------------------------------------------------------------

/**
 * Fetch all company_sites for the current tenant.
 * Includes sites with no jobs (Blocker 2 — general-purpose geofence editor).
 * staleTime: 60s — the site catalog changes rarely.
 */
export function useSites(): UseQueryResult<{ sites: SiteSummary[] }> {
  const opts = useApiOpts();
  return useApiQuery<{ sites: SiteSummary[] }>(opts, '/v1/sites', {
    queryKey: SITES_QUERY_KEY,
    staleTime: 60_000,
  });
}
